import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Promise from 'babel-runtime/core-js/promise';
import { getMenu, listRouterData } from '@/api/getmenu';
import Lockr from 'lockr';
/** 记录 侧边索引 */
var app = {
  state: {
    sidebar: {
      activeIndex: 0 // 目前激活的 行
    },
    navbar: {
      activeIndex: 0 // 导航目前是第几个 个人中心需要
    },
    navlist: [],
    menulist: []
  },

  mutations: {
    SET_ACTIVEINDEX: function SET_ACTIVEINDEX(state, path) {
      state.sidebar.activeIndex = path;
    },
    SET_NAVACTIVEINDEX: function SET_NAVACTIVEINDEX(state, path) {
      Lockr.set('navbarActIndex', path);
      state.navbar.activeIndex = path;
    },
    SET_NAVLIST: function SET_NAVLIST(state, data) {
      var listArr = [];
      if (data) {
        data.forEach(function (item, index) {
          var title = item.name,
              path = item.path,
              icon = item.icon;

          var type = index;
          listArr.push({
            title: title,
            icon: icon,
            path: path,
            type: type
          });
        });
      }
      state.navlist = listArr;
    },
    SET_MENULIST: function SET_MENULIST(state, data) {
      state.menulist = data;
    }
  },
  actions: {
    setMenu: function setMenu(_ref) {
      var commit = _ref.commit;

      return new _Promise(function (resolve, reject) {
        getMenu().then(function (res) {
          var listData = JSON.parse(_JSON$stringify(res));
          var routerConfData = listRouterData(res);
          commit('SET_NAVLIST', listData);
          commit('SET_MENULIST', routerConfData);
          resolve(routerConfData);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }
};

export default app;